import type { VariantProps } from "tailwind-variants";

import { createStyle } from "~/common/utils/create-style";

const menuItemContainerStyle = createStyle({
  base: [
    "flex w-full items-start transition-all duration-100 gap-4 whitespace-normal text-color-text-primary",
    "text-body-2 text-left truncate",
    "p-8 rounded-l",
  ],
  variants: {
    isActive: {
      true: "bg-primary-base",
      false: "hover:bg-overlay-30",
    },
    isDisabled: {
      true: "text-text-disabled hover:bg-transparent cursor-default",
      false: "",
    },
    background: {
      "on-white": "",
      "on-black": "",
    },
    theme: {
      light: "",
      dark: "",
    },
  },
  compoundVariants: [
    {
      isActive: true,
      theme: "light",
      className: "text-text-primary-on-dark",
    },
    {
      isActive: true,
      theme: "dark",
      className: "text-text-primary-on-light",
    },
  ],
});

const menuItemStyle = createStyle({
  slots: {
    content: "w-full flex flex-col",
    icon: "inline-flex items-center justify-center w-20 h-20",
    text: "",
    additionalInfo: "text-body-3 text-text-tertiary inline-block truncate",
    loader: "[&>div>div]:!bg-current",
  },
  variants: {
    isSingleLine: {
      true: {
        text: "inline-block truncate",
      },
      false: {
        text: "break-all line-clamp-3",
      },
    },
  },
})();

export type MenuItemVariants = VariantProps<typeof menuItemContainerStyle>;
export { menuItemContainerStyle, menuItemStyle };
